import React, { useState } from 'react';
import axios from 'axios';
import { SERVER_URL } from '../config';
import '../styles.css';
import './About.css';

export default function AboutScreen({ token }) {
  const [confirming, setConfirming] = useState(false);
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const handleOpenInBrowser = (url) => {
    window.open(url, '_blank'); // Opens the URL in a new tab
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const response = await axios.post(`${SERVER_URL}/users/delete-account`, { token, userPassword: password });
      if (response.data.ok) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('wishlist');
        window.location.reload();
      } else {
        setError(response.data.message || 'Could not delete the account.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Could not delete the account. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <div className="about-container">
        <p className="about-text"></p>
        {/* description of the app, what it can do and how */}
        <p className="about-text">Made in</p>
        <button className="about-link" onClick={() => handleOpenInBrowser('https://barcelonacodeschool.com')}>
          Barcelona Code School
        </button>
        <p className="about-text">We can teach you how to code web or mobile apps</p>
      </div>

      <div className="about-container about-danger">
        <p className="about-text">Delete account and all of your data</p>

        {!confirming ? (
          <>
            <p className="about-link about-link-danger" onClick={() => setConfirming(true)}>
              Delete me
            </p>
            <p className="about-text about-warning">This can not be undone!</p>
          </>
        ) : (
          <form className="about-delete-form" onSubmit={handleDelete}>
            <p className="about-text about-warning">
              Your account and your whole wishlist will be permanently deleted. This can not be undone.
            </p>
            <input
              type="password"
              className="about-input"
              placeholder="Confirm with your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
            />
            {error && <p className="about-text about-error">{error}</p>}
            <div className="about-delete-actions">
              <button
                type="button"
                className="about-link"
                onClick={() => { setConfirming(false); setPassword(''); setError(null); }}
                disabled={busy}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="about-link about-link-danger"
                disabled={busy || password.length === 0}
              >
                {busy ? 'Deleting…' : 'Delete forever'}
              </button>
            </div>
          </form>
        )}
      </div>
    </>
  );
}
